export const EVENT_SPACE_TYPE = {
  ROOM: 'ROOM',
  STAGE: 'STAGE',
  BOOTH: 'BOOTH',
} as const;

export type EventSpaceType = (typeof EVENT_SPACE_TYPE)[keyof typeof EVENT_SPACE_TYPE];
